function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
import isBlank from "@sedan-utils/is-blank";
import { get } from "lodash";
import { ViewBuilderService } from "imagica-corekit/dist/base/service/ViewBuilderService";
import { ViewBuilderWorker } from "./ViewBuilderWorker";
import { UploadService } from "imagica-corekit/dist/base/service/UploadService";
import { Analytics } from "imagica-corekit/dist/base/port/Analytics";
export var ViewBuilderState = /*#__PURE__*/_createClass(function ViewBuilderState() {
  _classCallCheck(this, ViewBuilderState);
});
export var ViewBuilderBloc = /*#__PURE__*/function () {
  function ViewBuilderBloc(getIt) {
    _classCallCheck(this, ViewBuilderBloc);
    _defineProperty(this, "state", new ViewBuilderState());
    _defineProperty(this, "props", void 0);
    _defineProperty(this, "viewBuilderService", void 0);
    _defineProperty(this, "uploadService", void 0);
    _defineProperty(this, "analytics", void 0);
    this.getIt = getIt;
    this.viewBuilderService = getIt(ViewBuilderService);
    this.uploadService = getIt(UploadService);
    this.analytics = getIt(Analytics);
  }
  _createClass(ViewBuilderBloc, [{
    key: "setProps",
    value: function setProps(props) {
      this.props = props;
    }
  }, {
    key: "handleViewBuilderData",
    value: function handleViewBuilderData(updateState) {
      var _this = this;
      if (updateState) {
        // 文本编辑过/数据为空，且不能正在请求中
        if (isBlank(get(this, "props.viewBuilderData.domList.0.screenInfo")) && get(this, "props.viewBuilderData.loadingHtml") === false) {
          new ViewBuilderWorker({
            id: this.props.transformData.id,
            textAreaValue: this.props.transformData.data.textAreaValue,
            viewBuilderService: this.viewBuilderService,
            uploadService: this.uploadService,
            setNodes: this.props.setNodes,
            updateShareAppData: function updateShareAppData(viewBuilderData) {
              var _this$props$onUpdateN, _this$props;
              // 这里重新赋值transformData的内容以便给share app更新
              var transformData = _objectSpread(_objectSpread({}, _this.props.transformData), {}, {
                data: _objectSpread(_objectSpread({}, _this.props.transformData.data), {}, {
                  // 如果run时显示的是text界面，那么这里闭包加入时showBuilderUI变量为false，需要更新为true，以便后续判定状态正确
                  showBuilderUI: true,
                  viewBuilderData: _objectSpread(_objectSpread({}, _this.props.transformData.data.viewBuilderData), viewBuilderData)
                })
              });
              (_this$props$onUpdateN = (_this$props = _this.props).onUpdateNode) === null || _this$props$onUpdateN === void 0 || _this$props$onUpdateN.call(_this$props, {
                transformData: transformData
              });
            }
          }).getViewBuilderData();
        }
      }
    }
  }, {
    key: "clickChangeBuilderUI",
    value: function clickChangeBuilderUI() {
      var updateState = !this.props.showBuilderUI;
      this.props.changeShowBuilderUI(updateState);
      this.handleViewBuilderData(updateState);
      this.analytics.logEvent("click_view_builder_toggle_button", {
        button_text: updateState ? "Build UI" : "View text"
      });
    }
  }]);
  return ViewBuilderBloc;
}();